export interface TextSegment {
  text: string;
  highlighted: boolean;
}

function escapeRegExp(value: string): string {
  return value.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}

// The term comes from the backend (CaseNoteResponse.searchHighlightTerm) — the frontend
// applies no matching rules of its own beyond locating this literal string in the displayed text
function buildTermRegex(searchTerm: string): RegExp | null {
  if (searchTerm.trim().length === 0) {
    return null;
  }

  return new RegExp(escapeRegExp(searchTerm), "gi");
}

/**
 * Splits the text into consecutive segments, marking every case-insensitive occurrence
 * of the term as highlighted.
 */
export function splitByMatches(text: string, searchTerm: string): TextSegment[] {
  const regex = buildTermRegex(searchTerm);
  if (!text || !regex) {
    return [{ text, highlighted: false }];
  }

  const segments: TextSegment[] = [];
  let lastIndex = 0;

  for (const match of text.matchAll(regex)) {
    if (match.index > lastIndex) {
      segments.push({ text: text.slice(lastIndex, match.index), highlighted: false });
    }
    segments.push({ text: match[0], highlighted: true });
    lastIndex = match.index + match[0].length;
  }

  if (lastIndex < text.length) {
    segments.push({ text: text.slice(lastIndex), highlighted: false });
  }

  return segments;
}
